var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbox no footer"},[_c('Row',[_c('Col',{staticClass:"link"},[_c('p',[_vm._v("Copyright © 2018~2020 Blockchain Venture Capital | All Rights Reserved")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }